import { InputBase, Button } from '@material-ui/core';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretCircleRight } from '@fortawesome/pro-duotone-svg-icons';
var useStyles = function () {
    var _a, _b;
    var _c = useTheme(), shape = _c.shape, spacing = _c.spacing, palette = _c.palette, breakpoints = _c.breakpoints, transitions = _c.transitions;
    return makeStyles({
        search: (_a = {
                position: 'relative',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                borderRadius: shape.borderRadius,
                backgroundColor: fade(palette.common.white, 0.15),
                '&:hover': {
                    backgroundColor: fade(palette.common.white, 0.25)
                },
                marginLeft: 0,
                marginRight: spacing(3),
                width: '100%'
            },
            _a[breakpoints.up('sm')] = {
                marginLeft: spacing(),
                width: 'auto'
            },
            _a),
        searchIcon: {
            paddingLeft: spacing(2),
            paddingTop: spacing(0.25),
            height: '100%',
            pointerEvents: 'none',
            alignItems: 'center',
            justifyContent: 'center'
        },
        searchButton: {
            minWidth: 0
        },
        inputRoot: {
            color: 'inherit',
            width: '100%'
        },
        inputInput: (_b = {
                paddingTop: spacing(),
                paddingRight: spacing(0),
                paddingBottom: spacing(),
                paddingLeft: spacing(),
                transition: transitions.create('width'),
                width: '100%'
            },
            _b[breakpoints.up('sm')] = {
                width: 150,
                '&:focus': {
                    width: 200
                }
            },
            _b)
    })();
};
export var SearchBox = function (_a) {
    var onSearch = _a.onSearch, clearOnSearch = _a.clearOnSearch;
    var classes = useStyles();
    var _b = useState(''), value = _b[0], setValue = _b[1];
    return (React.createElement("form", { className: classes.search, onSubmit: function (e) {
            if (onSearch)
                onSearch(value);
            if (clearOnSearch)
                setValue('');
            e.preventDefault();
        } },
        React.createElement(InputBase, { placeholder: 'Claim #', classes: {
                root: classes.inputRoot,
                input: classes.inputInput
            }, value: value, onChange: function (e) { return setValue(e.target.value); } }),
        React.createElement("div", { className: classes.searchIcon },
            React.createElement(Button, { type: 'submit', className: classes.searchButton },
                React.createElement(FontAwesomeIcon, { icon: faCaretCircleRight, size: 'lg' })))));
};
//# sourceMappingURL=search-box.js.map